<template>
  <div id="app">
    <byjove-app :appsettings="appsettings" :include-footer="false">
      <app-nav></app-nav>
      <template v-slot:footer>
        <router-link to="/about">{{ appsettings.appTitle}} {{ appsettings.version }}</router-link>
      </template>
    </byjove-app>
  </div>
</template>

<script>
import {ByjoveApp} from 'byjove'
import AppNav from './components/AppNav.vue'
import appsettings from './appsettings'

export default {
    name: 'app',
    components: {
        ByjoveApp,
        AppNav,
    },
    data() {
        return {
            appsettings: appsettings,
        }
    },
    beforeCreate() {
        // TODO: this is getting out of hand already, with just 2
        // settings..  of course can just remove expose_home, but
        // ideally figure out a better pattern to use for this
        let params = {
            section: 'veranda3',
            option: 'expose_home',
        }
        this.$http.get('/api/feature-flag', {params: params}).then(response => {
            if (response.data.success) {

                // keep the setting we just fetched
                this.$store.commit('SET_EXPOSE_HOME', response.data.value)

                // then fetch 2nd setting
                params = {
                    section: 'veranda3',
                    option: 'expose_payments',
                }
                this.$http.get('/api/feature-flag', {params: params}).then(response => {
                    if (response.data.success) {

                        // keep that setting, and consider the job done
                        this.$store.commit('SET_EXPOSE_PAYMENTS', response.data.value)
                        this.$store.commit('SET_SETTINGS_ESTABLISHED', true)
                    }
                })
            }
        })
    },
}
</script>

<style lang="scss">

// note, this borrowed heavily from the Buefy doc example at
// https://buefy.org/documentation/customization

// Import Bulma's core
@import "~bulma/sass/utilities/_all";

// Set your colors
/* $primary: #8c67ef; */
/* $primary: #283562; */
/* $primary: #4a70b7; */
/* $primary: #ab967d; */
$primary: #003A43;
$primary-invert: findColorInvert($primary);
/* $twitter: #4099FF; */
/* $twitter-invert: findColorInvert($twitter); */

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
    "white": ($white, $black),
    "black": ($black, $white),
    "light": ($light, $light-invert),
    "dark": ($dark, $dark-invert),
    "primary": ($primary, $primary-invert),
    "info": ($info, $info-invert),
    "success": ($success, $success-invert),
    "warning": ($warning, $warning-invert),
    "danger": ($danger, $danger-invert),
    /* "twitter": ($twitter, $twitter-invert) */
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// default modal width is 640px but it seems like sometimes we just need more
$modal-content-width: 700px;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";

</style>

<style>

/******************************
 * main app layout
******************************/

#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
}
.main-container {
    display: flex;
    min-height: 100vh;
    flex-direction: column;
    padding-bottom: 1rem;
}
nav img {
    margin: 3px;
    /* TODO: (how) should we limit the height? */
    /* height: 40px; */
}
.page-content-wrapper {
    min-width: 70%;
    margin: 0 auto;
}
.page-content {
    flex: 1;
    padding: 0.5rem 1rem 0.5rem 0.5rem;
}
.footer {
    /* TODO: what about this? */
    /* display: none; */
    text-align: center;
}

/******************************
 * general stuff
******************************/

h1 {
    font-size: 1.5rem;
    font-weight: bold;
    margin-bottom: 0.5rem;
}
h2 {
    font-size: 1.2rem;
    font-weight: bold;
    margin-bottom: 0.5rem;
}

/******************************
 * root-user
******************************/

[role=menuitem].root-user {
    background-color: red;
}

/******************************
 * model-index
******************************/

.model-index .menu {
    margin-bottom: 1rem;
}

.model-index .menu-list li {
    border-bottom: 1px solid #4a4a4a;
}

.model-index .menu-list li:last-child {
    border: 0px;
}

/******************************
 * model-crud
******************************/

.model-crud .menu {
    margin-bottom: 1rem;
}

.model-crud .menu-list li {
    border-bottom: 1px solid #4a4a4a;
}

.model-crud .menu-list li:last-child {
    border: 0px;
}

</style>
